/**
 * Beauty Basket - Core Theme Javascript
 * Handles all interactive behaviors: drawer, modal, wishlist, search suggestion, and responsive navigation.
 * Integrated with Shopify AJAX Cart API.
 */

document.addEventListener("DOMContentLoaded", function() {
  initAnnouncementBar();
  initStickyHeader();
  initMobileNav();
  initSearchDrawer();
  initCartDrawer();
  initQuickView();
  initWishlist();
  initProductTabs();
  initProductPage();
  initStickyATC();
  initWhatsAppFloating();
  initSlideshow();
  initScrollReveal();
  initAllCollectionFilters();
});

/* --- Announcement Bar Slider --- */
function initAnnouncementBar() {
  const messages = document.querySelectorAll(".announcement-bar__message");
  if (messages.length === 0) return;
  
  const prevBtn = document.querySelector(".announcement-bar__nav-btn.prev-btn");
  const nextBtn = document.querySelector(".announcement-bar__nav-btn.next-btn");
  let currentIndex = 0;
  let intervalId;
  
  const showMessage = (index) => {
    messages[currentIndex].classList.remove("active");
    currentIndex = index;
    messages[currentIndex].classList.add("active");
  };
  
  const nextMessage = () => {
    let next = (currentIndex + 1) % messages.length;
    showMessage(next);
  };
  
  const prevMessage = () => {
    let prev = (currentIndex - 1 + messages.length) % messages.length;
    showMessage(prev);
  };
  
  const startRotation = () => {
    if (messages.length > 1) {
      intervalId = setInterval(nextMessage, 4000);
    }
  };
  
  const stopRotation = () => {
    clearInterval(intervalId);
  };
  
  if (prevBtn && nextBtn && messages.length > 1) {
    prevBtn.addEventListener("click", (e) => {
      e.preventDefault();
      stopRotation();
      prevMessage();
      startRotation();
    });
    
    nextBtn.addEventListener("click", (e) => {
      e.preventDefault();
      stopRotation();
      nextMessage();
      startRotation();
    });
  }
  
  startRotation();
}

/* --- Sticky Header & Shrink Scroll --- */
function initStickyHeader() {
  const headerWrapper = document.querySelector(".site-header-wrapper");
  if (!headerWrapper) return;
  
  window.addEventListener("scroll", () => {
    if (window.scrollY > 30) {
      headerWrapper.classList.add("sticky");
    } else {
      headerWrapper.classList.remove("sticky");
    }
  });
}

/* --- Hero Slideshow Slider Controller --- */
function initSlideshow() {
  const slides = document.querySelectorAll(".slide");
  const dots = document.querySelectorAll(".slideshow-dot");
  if (slides.length <= 1) return;
  
  let currentSlide = 0;
  let slideInterval;
  
  const showSlide = (index) => {
    slides.forEach(s => s.classList.remove("active"));
    dots.forEach(d => d.classList.remove("active"));
    
    currentSlide = index;
    slides[currentSlide].classList.add("active");
    if (dots[currentSlide]) dots[currentSlide].classList.add("active");
  };
  
  const nextSlide = () => {
    let next = (currentSlide + 1) % slides.length;
    showSlide(next);
  };
  
  const startInterval = () => {
    slideInterval = setInterval(nextSlide, 5000);
  };
  
  const resetInterval = () => {
    clearInterval(slideInterval);
    startInterval();
  };
  
  dots.forEach((dot, idx) => {
    dot.addEventListener("click", () => {
      showSlide(idx);
      resetInterval();
    });
  });
  
  startInterval();
}

/* --- Mobile Nav Hamburger Menu Drawer --- */
function initMobileNav() {
  const burgerBtn = document.querySelector(".hamburger-menu-btn");
  const closeBtn = document.querySelector(".mobile-nav-close");
  const drawer = document.querySelector(".mobile-nav-drawer");
  
  if (!burgerBtn || !drawer) return;
  
  burgerBtn.addEventListener("click", (e) => {
    e.preventDefault();
    drawer.classList.add("open");
  });
  
  if (closeBtn) {
    closeBtn.addEventListener("click", (e) => {
      e.preventDefault();
      drawer.classList.remove("open");
    });
  }
  
  document.addEventListener("click", (e) => {
    if (drawer.classList.contains("open") && !drawer.contains(e.target) && !burgerBtn.contains(e.target)) {
      drawer.classList.remove("open");
    }
  });
}

/* --- Search Drawer & Autocomplete Suggestions --- */
function initSearchDrawer() {
  const searchTriggers = document.querySelectorAll(".search-trigger");
  const searchDrawer = document.querySelector(".search-drawer");
  const closeBtn = document.querySelector(".search-close-btn");
  
  if (searchDrawer) {
    searchTriggers.forEach(trigger => {
      trigger.addEventListener("click", (e) => {
        e.preventDefault();
        searchDrawer.classList.add("active");
        const drawerInput = searchDrawer.querySelector(".search-input-field");
        setTimeout(() => drawerInput && drawerInput.focus(), 300);
      });
    });
    
    if (closeBtn) {
      closeBtn.addEventListener("click", (e) => {
        e.preventDefault();
        searchDrawer.classList.remove("active");
      });
    }
  }
  
  const searchInputs = document.querySelectorAll(".search-input-field");
  searchInputs.forEach(input => {
    const parentForm = input.closest("form") || input.parentElement;
    if (!parentForm) return;
    
    const suggestionsBox = parentForm.querySelector(".search-suggestions");
    if (!suggestionsBox) return;
    
    const renderSuggestions = (items) => {
      if (!items || items.length === 0) {
        suggestionsBox.innerHTML = '<div style="padding:10px;text-align:center;font-size:12px;color:#6A5D57;">No results found.</div>';
        return;
      }
      
      let html = "";
      items.forEach(p => {
        const title = p.title || "";
        const url = p.url || `/products/${p.handle}`;
        const price = p.price ? formatShopifyMoney(p.price) : (p.variants && p.variants[0] ? `Rs. ${parseFloat(p.variants[0].price).toLocaleString()}` : "");
        const img = p.featured_image || p.image || (p.images && p.images[0] ? p.images[0].src : "");
        html += `
          <a href="${url}" class="search-suggestion-item">
            ${img ? `<img src="${img}" alt="${title}">` : ""}
            <div class="search-suggestion-details">
              <h4>${title}</h4>
              <div class="search-suggestion-price">${price}</div>
            </div>
          </a>
        `;
      });
      suggestionsBox.innerHTML = html;
    };
    
    input.addEventListener("input", function() {
      const query = this.value.trim();
      if (query.length < 2) {
        suggestionsBox.innerHTML = "";
        suggestionsBox.style.display = "none";
        return;
      }
      
      suggestionsBox.style.display = "block";
      
      fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=5`)
        .then(res => {
          if (!res.ok) throw new Error("Suggest API not available");
          return res.json();
        })
        .then(data => {
          const products = data.resources && data.resources.results && data.resources.results.products ? data.resources.results.products : [];
          renderSuggestions(products);
        })
        .catch(() => {
          fetch("/products.json?limit=50")
            .then(res => res.json())
            .then(data => {
              const filtered = (data.products || []).filter(p => 
                p.title.toLowerCase().includes(query.toLowerCase()) || 
                (p.vendor && p.vendor.toLowerCase().includes(query.toLowerCase())) ||
                (p.tags && p.tags.some(tag => tag.toLowerCase().includes(query.toLowerCase())))
              ).slice(0, 5);
              renderSuggestions(filtered);
            })
            .catch(() => {
              suggestionsBox.innerHTML = '<div style="padding:10px;text-align:center;font-size:12px;color:#6A5D57;">Press Enter to search.</div>';
            });
        });
    });
    
    document.addEventListener("click", function(e) {
      if (!input.contains(e.target) && !suggestionsBox.contains(e.target)) {
        suggestionsBox.style.display = "none";
      }
    });
    
    input.addEventListener("focus", function() {
      if (this.value.trim().length >= 2) {
        suggestionsBox.style.display = "block";
      }
    });
  });
}

/* --- Currency & Money Formatter --- */
function formatShopifyMoney(cents) {
  if (typeof cents === "string") cents = parseFloat(cents);
  if (isNaN(cents)) return "Rs. 0";
  // If price is in standard Shopify cents
  const rupees = cents > 100000 ? Math.round(cents / 100) : Math.round(cents);
  return "Rs. " + rupees.toLocaleString();
}

/* --- Official Shopify Cart API Controller --- */
function shopifyFetchCart() {
  return fetch("/cart.js", {
    headers: { "Accept": "application/json" }
  })
  .then(res => res.json())
  .then(cart => {
    updateCartBubbles(cart.item_count);
    renderCartDrawer(cart);
    return cart;
  })
  .catch(err => {
    console.error("Error fetching Shopify cart:", err);
  });
}

function shopifyAddToCart(variantId, quantity, btnElement, callback) {
  if (!variantId || variantId === "mock-1" || variantId === "mock-variant") {
    alert("This item is currently unavailable or a preview mockup.");
    return;
  }

  let origHtml = "";
  if (btnElement) {
    origHtml = btnElement.innerHTML;
    btnElement.disabled = true;
    btnElement.innerHTML = "Adding...";
  }

  fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Accept": "application/json"
    },
    body: JSON.stringify({
      id: Number(variantId),
      quantity: Number(quantity) || 1
    })
  })
  .then(res => {
    return res.json().then(data => {
      if (!res.ok) {
        throw new Error(data.description || data.message || "Failed to add item to cart.");
      }
      return data;
    });
  })
  .then(data => {
    if (btnElement) {
      btnElement.innerHTML = "Added ✓";
      setTimeout(() => {
        btnElement.innerHTML = origHtml;
        btnElement.disabled = false;
      }, 1200);
    }
    
    shopifyFetchCart().then(() => {
      openCartDrawer();
    });
    
    if (callback) callback(null, data);
  })
  .catch(err => {
    console.error("Add to cart error:", err);
    if (btnElement) {
      btnElement.innerHTML = origHtml;
      btnElement.disabled = false;
    }
    alert(err.message || "Unable to add product to cart. Please check availability.");
    if (callback) callback(err);
  });
}

function shopifyChangeItem(lineKey, quantity) {
  const container = document.querySelector(".cart-drawer-items");
  if (container) {
    container.style.opacity = "0.5";
    container.style.pointerEvents = "none";
  }

  fetch("/cart/change.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Accept": "application/json"
    },
    body: JSON.stringify({
      id: lineKey,
      quantity: Number(quantity)
    })
  })
  .then(res => res.json())
  .then(cart => {
    if (container) {
      container.style.opacity = "";
      container.style.pointerEvents = "";
    }
    updateCartBubbles(cart.item_count);
    renderCartDrawer(cart);
  })
  .catch(err => {
    console.error("Cart update error:", err);
    if (container) {
      container.style.opacity = "";
      container.style.pointerEvents = "";
    }
  });
}

function updateCartBubbles(count) {
  const numCount = Number(count) || 0;
  const bubbles = document.querySelectorAll(".cart-count-bubble, .mobile-cart-count");
  bubbles.forEach(b => {
    b.textContent = numCount;
    if (b.classList.contains("mobile-bottom-nav-item") || b.closest(".mobile-bottom-nav-item")) {
      b.style.display = numCount > 0 ? "flex" : "none";
    } else {
      b.style.display = numCount > 0 ? "inline-flex" : "none";
    }
    if (numCount > 0) {
      b.classList.remove("pulse-add");
      void b.offsetWidth;
      b.classList.add("pulse-add");
    }
  });
}

function openCartDrawer() {
  const cartDrawer = document.querySelector(".cart-drawer");
  const cartOverlay = document.querySelector(".cart-drawer-overlay");
  if (cartDrawer && cartOverlay) {
    cartDrawer.classList.add("active");
    cartOverlay.classList.add("active");
  }
}

function closeCartDrawer() {
  const cartDrawer = document.querySelector(".cart-drawer");
  const cartOverlay = document.querySelector(".cart-drawer-overlay");
  if (cartDrawer && cartOverlay) {
    cartDrawer.classList.remove("active");
    cartOverlay.classList.remove("active");
  }
}

function renderCartDrawer(cart) {
  const container = document.querySelector(".cart-drawer-items");
  const subtotalVal = document.getElementById("cart-drawer-subtotal-val");
  if (!container) return;

  if (!cart || !cart.items || cart.items.length === 0) {
    container.innerHTML = '<div class="cart-drawer-empty-text">Your cart is empty.</div>';
    if (subtotalVal) subtotalVal.textContent = "Rs. 0";
    return;
  }

  let html = "";
  cart.items.forEach(item => {
    const itemTotal = formatShopifyMoney(item.final_line_price);
    const itemImg = item.featured_image ? item.featured_image.url : (item.image || "https://placehold.co/100x100/FFF0ED/2C221E?text=Beauty+Basket");
    const variantTitle = item.variant_title && item.variant_title !== "Default Title" ? `<div style='font-size:11px;color:#6A5D57;margin-bottom:4px;'>${item.variant_title}</div>` : "";
    
    html += `
      <div class="cart-drawer-item" data-key="${item.key}">
        <div class="cart-drawer-item-img">
          <img src="${itemImg}" alt="${item.title}">
        </div>
        <div class="cart-drawer-item-details">
          <h4>${item.product_title || item.title}</h4>
          ${variantTitle}
          <div class="cart-drawer-item-price">${itemTotal}</div>
          <div class="cart-qty-selector">
            <button class="cart-qty-btn decrease-qty" data-key="${item.key}" data-qty="${item.quantity - 1}">-</button>
            <span class="cart-qty-val">${item.quantity}</span>
            <button class="cart-qty-btn increase-qty" data-key="${item.key}" data-qty="${item.quantity + 1}">+</button>
          </div>
        </div>
        <button class="cart-drawer-item-remove remove-item-btn" data-key="${item.key}">
          <svg style="width:18px;height:18px;" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
          </svg>
        </button>
      </div>
    `;
  });

  container.innerHTML = html;
  if (subtotalVal) subtotalVal.textContent = formatShopifyMoney(cart.total_price);

  container.querySelectorAll(".increase-qty").forEach(btn => {
    btn.addEventListener("click", function() {
      const key = this.getAttribute("data-key");
      const nextQty = parseInt(this.getAttribute("data-qty"));
      shopifyChangeItem(key, nextQty);
    });
  });

  container.querySelectorAll(".decrease-qty").forEach(btn => {
    btn.addEventListener("click", function() {
      const key = this.getAttribute("data-key");
      const nextQty = parseInt(this.getAttribute("data-qty"));
      shopifyChangeItem(key, nextQty);
    });
  });

  container.querySelectorAll(".remove-item-btn").forEach(btn => {
    btn.addEventListener("click", function() {
      const key = this.getAttribute("data-key");
      shopifyChangeItem(key, 0);
    });
  });
}

/* --- Cart Drawer Setup --- */
function initCartDrawer() {
  const cartDrawer = document.querySelector(".cart-drawer");
  const cartOverlay = document.querySelector(".cart-drawer-overlay");
  const cartTriggers = document.querySelectorAll(".cart-trigger");
  const closeBtn = document.querySelector(".cart-drawer-close");

  if (!cartDrawer || !cartOverlay) return;

  cartTriggers.forEach(trigger => {
    trigger.addEventListener("click", (e) => {
      e.preventDefault();
      openCartDrawer();
      shopifyFetchCart();
    });
  });

  if (closeBtn) closeBtn.addEventListener("click", (e) => { e.preventDefault(); closeCartDrawer(); });
  cartOverlay.addEventListener("click", closeCartDrawer);

  // Initial cart fetch to sync bubbles and drawer
  shopifyFetchCart();

  // Listen for Add To Cart buttons across the site
  document.body.addEventListener("click", function(e) {
    const atcBtn = e.target.closest(".add-to-cart-ajax");
    if (atcBtn) {
      if (atcBtn.disabled || atcBtn.classList.contains("out-of-stock-btn") || atcBtn.getAttribute("aria-disabled") === "true") {
        e.preventDefault();
        return;
      }
      e.preventDefault();
      
      const form = atcBtn.closest("form");
      let qty = 1;
      let variantId = atcBtn.getAttribute("data-variant-id");
      
      if (form) {
        const qtyInput = form.querySelector("[name='quantity']");
        if (qtyInput) qty = parseInt(qtyInput.value) || 1;
        const idInput = form.querySelector("[name='id']");
        if (idInput && idInput.value) variantId = idInput.value;
      }
      
      if (!variantId || variantId === "mock-1" || variantId === "mock-variant") {
        alert("Please select an available product variant.");
        return;
      }

      shopifyAddToCart(variantId, qty, atcBtn);

      const activeQuickView = document.querySelector(".quick-view-modal.active");
      if (activeQuickView) activeQuickView.classList.remove("active");
    }
  });

  // Listen for Buy It Now button (direct to checkout)
  document.body.addEventListener("click", function(e) {
    const binBtn = e.target.closest("#buy-it-now-btn");
    if (binBtn) {
      e.preventDefault();
      const form = binBtn.closest("form");
      let variantId = null;
      let qty = 1;

      if (form) {
        const idInput = form.querySelector("[name='id']");
        if (idInput) variantId = idInput.value;
        const qtyInput = form.querySelector("[name='quantity']");
        if (qtyInput) qty = parseInt(qtyInput.value) || 1;
      }

      if (!variantId) {
        const atc = document.getElementById("main-add-to-cart-btn");
        if (atc) variantId = atc.getAttribute("data-variant-id");
      }

      if (!variantId || variantId === "mock-1" || variantId === "mock-variant") {
        alert("Please select a product variant first.");
        return;
      }

      binBtn.disabled = true;
      binBtn.textContent = "Processing...";

      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify({ id: Number(variantId), quantity: qty })
      })
      .then(res => res.json())
      .then(() => {
        window.location.href = "/checkout";
      })
      .catch(err => {
        console.error("Buy It Now error:", err);
        binBtn.disabled = false;
        binBtn.textContent = "Buy It Now";
        alert("Unable to proceed to checkout. Please try again.");
      });
    }
  });
}

/* --- Product Page Options & Variant Sync --- */
function initProductPage() {
  const select = document.getElementById("ProductSelect");
  if (!select) return;

  select.addEventListener("change", function() {
    const opt = this.options[this.selectedIndex];
    if (!opt) return;

    const price = opt.getAttribute("data-price");
    const comparePrice = opt.getAttribute("data-compare-price");
    const available = opt.getAttribute("data-available") === "true";
    const img = opt.getAttribute("data-image");
    const variantId = this.value;

    const priceEl = document.getElementById("MainProductPrice");
    if (priceEl && price) priceEl.textContent = price;

    const atcBtn = document.getElementById("main-add-to-cart-btn");
    const binBtn = document.getElementById("buy-it-now-btn");
    const stickyAtcBtn = document.querySelector(".sticky-atc-btn");
    const stockBadge = document.getElementById("MainProductStockBadge");
    const qtyWrap = document.querySelector(".product-quantity-atc-wrap .product-qty-box");

    if (stockBadge) {
      if (!available) {
        stockBadge.textContent = "Out of Stock";
        stockBadge.className = "stock-badge badge-out-of-stock";
        stockBadge.style.backgroundColor = "#FEE2E2";
        stockBadge.style.color = "#DC2626";
        stockBadge.style.borderColor = "#FCA5A5";
      } else {
        stockBadge.textContent = "In Stock";
        stockBadge.className = "stock-badge badge-in-stock";
        stockBadge.style.backgroundColor = "#DEF7EC";
        stockBadge.style.color = "#03543F";
        stockBadge.style.borderColor = "#BCF0DA";
      }
    }

    if (qtyWrap) {
      if (!available) {
        qtyWrap.style.opacity = "0.4";
        qtyWrap.style.pointerEvents = "none";
      } else {
        qtyWrap.style.opacity = "1";
        qtyWrap.style.pointerEvents = "auto";
      }
    }

    if (atcBtn) {
      atcBtn.setAttribute("data-variant-id", variantId);
      if (!available) {
        atcBtn.disabled = true;
        atcBtn.textContent = "Out of Stock";
        atcBtn.classList.add("out-of-stock-btn");
      } else {
        atcBtn.disabled = false;
        atcBtn.textContent = "Add to Bag";
        atcBtn.classList.remove("out-of-stock-btn");
      }
    }

    if (stickyAtcBtn) {
      stickyAtcBtn.setAttribute("data-variant-id", variantId);
      stickyAtcBtn.disabled = !available;
      stickyAtcBtn.textContent = !available ? "Out of Stock" : "Add to Bag";
      if (!available) {
        stickyAtcBtn.classList.add("out-of-stock-btn");
      } else {
        stickyAtcBtn.classList.remove("out-of-stock-btn");
      }
    }

    if (binBtn) {
      binBtn.disabled = !available;
      binBtn.style.display = !available ? "none" : "";
    }

    if (img) {
      const mainImg = document.getElementById("MainProductImage");
      if (mainImg) mainImg.src = img;
    }
  });
}

/* --- Quick View Modal Controller --- */
function initQuickView() {
  const modal = document.querySelector(".quick-view-modal");
  const closeBtn = document.querySelector(".quick-view-close");
  
  if (!modal) return;
  
  document.body.addEventListener("click", function(e) {
    const trigger = e.target.closest(".quick-view-trigger");
    if (trigger) {
      e.preventDefault();
      e.stopPropagation();
      
      const title = trigger.getAttribute("data-product-title") || "";
      const rawPrice = trigger.getAttribute("data-product-price") || "0";
      const img = trigger.getAttribute("data-product-image") || "";
      const desc = trigger.getAttribute("data-product-desc") || "Treat your skin to the luxury formulation of this premium beauty item. Formulated using carefully selected authentic ingredients to lock in hydration and glow.";
      const vendor = trigger.getAttribute("data-product-vendor") || "Beauty Basket";
      const variantId = trigger.getAttribute("data-variant-id") || "";
      
      const numPrice = parseFloat(rawPrice);
      const formattedPrice = isNaN(numPrice) || numPrice <= 0 ? "" : `Rs. ${numPrice.toLocaleString()}`;
      
      const vendorEl = modal.querySelector(".quick-view-vendor");
      if (vendorEl) vendorEl.textContent = vendor;

      const titleEl = modal.querySelector(".quick-view-title");
      if (titleEl) titleEl.textContent = title;

      const priceEl = modal.querySelector(".quick-view-price");
      if (priceEl) priceEl.textContent = formattedPrice;

      const cardRating = trigger.closest(".product-card") ? trigger.closest(".product-card").querySelector(".product-rating span") : null;
      const ratingText = trigger.getAttribute("data-product-rating") || (cardRating ? cardRating.textContent.trim() : "(4.9)");
      const ratingEl = modal.querySelector(".quick-view-rating-num");
      if (ratingEl) ratingEl.textContent = ratingText.startsWith("(") ? ratingText : `(${ratingText})`;

      const descEl = modal.querySelector(".quick-view-desc");
      if (descEl) descEl.textContent = desc;

      const imgEl = modal.querySelector(".quick-view-media img");
      if (imgEl) {
        imgEl.setAttribute("src", img);
        imgEl.setAttribute("alt", title);
      }
      
      const isAvailable = trigger.getAttribute("data-product-available") !== "false";
      
      const atcBtn = modal.querySelector(".quick-view-atc");
      if (atcBtn) {
        atcBtn.setAttribute("data-variant-id", variantId);
        atcBtn.setAttribute("data-product-title", title);
        atcBtn.setAttribute("data-product-price", rawPrice);
        atcBtn.setAttribute("data-product-image", img);

        if (!isAvailable) {
          atcBtn.disabled = true;
          atcBtn.textContent = "Out of Stock";
          atcBtn.classList.add("out-of-stock-btn");
        } else {
          atcBtn.disabled = false;
          atcBtn.textContent = "Add to Cart";
          atcBtn.classList.remove("out-of-stock-btn");
        }
      }
      
      modal.classList.add("active");
    }
  });
  
  const closeModal = () => modal.classList.remove("active");
  if (closeBtn) closeBtn.addEventListener("click", (e) => { e.preventDefault(); closeModal(); });
  modal.addEventListener("click", (e) => {
    if (e.target === modal) closeModal();
  });
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && modal.classList.contains("active")) {
      closeModal();
    }
  });
}

/* --- Unified Collection Filtering & Pagination Management --- */

function updateCollectionPaginationVisibility() {
  const pagination = document.querySelector(".collection-pagination") || document.querySelector("[data-pagination]");
  if (!pagination) return;
  const urlParams = new URLSearchParams(window.location.search);
  const hasFilter = !!(
    urlParams.get("brand") ||
    urlParams.get("category") ||
    urlParams.get("type") ||
    urlParams.get("concern") ||
    urlParams.get("price")
  );
  pagination.style.display = hasFilter ? "none" : "";
}

function syncCollectionVisibility() {
  const cards = document.querySelectorAll(".collection-product-grid .product-card");
  let visibleCount = 0;

  cards.forEach(function(card) {
    const brandHidden = card.getAttribute("data-brand-hidden") === "true";
    const concernHidden = card.getAttribute("data-concern-hidden") === "true";
    const categoryHidden = card.getAttribute("data-category-hidden") === "true";
    const priceHidden = card.getAttribute("data-price-hidden") === "true";

    const isHidden = brandHidden || concernHidden || categoryHidden || priceHidden;
    card.style.display = isHidden ? "none" : "";
    if (!isHidden) {
      visibleCount++;
    }
  });

  // Empty state handling
  const grid = document.querySelector(".collection-product-grid");
  let emptyMsg = document.getElementById("collection-no-results");
  if (visibleCount === 0 && cards.length > 0) {
    if (!emptyMsg && grid) {
      emptyMsg = document.createElement("div");
      emptyMsg.id = "collection-no-results";
      emptyMsg.style.cssText = "grid-column: 1 / -1; text-align: center; padding: 50px 20px; background: var(--color-bg-beige, #fbf7f4); border-radius: 12px; border: 1px dashed var(--color-border); margin: 20px 0;";
      emptyMsg.innerHTML = [
        '<p style="font-size: 16px; font-weight: 500; color: var(--color-text-primary); margin-bottom: 8px;">No products match your selected filter.</p>',
        '<p style="font-size: 13px; color: var(--color-text-secondary); margin-bottom: 18px;">Try resetting filters to view all products in the catalog.</p>',
        '<button type="button" id="reset-all-filters-btn" style="padding: 10px 22px; background: var(--color-primary-green, #173f35); color: white; border: none; border-radius: 25px; font-size: 13px; font-weight: 600; cursor: pointer;">',
        '  Reset All Filters',
        '</button>'
      ].join('');
      grid.appendChild(emptyMsg);
      const resetBtn = document.getElementById("reset-all-filters-btn");
      if (resetBtn) {
        resetBtn.addEventListener("click", function() {
          clearAllCollectionFilters();
        });
      }
    } else if (emptyMsg) {
      emptyMsg.style.display = "";
    }
  } else if (emptyMsg) {
    emptyMsg.style.display = "none";
  }

  // Update product count
  const countEl = document.querySelector(".collection-product-count");
  if (countEl) {
    const urlParams = new URLSearchParams(window.location.search);
    const brand = urlParams.get("brand");
    const cat = urlParams.get("category") || urlParams.get("type");
    const concern = urlParams.get("concern");
    const price = urlParams.get("price");
    const labels = [];
    if (brand) labels.push(brand);
    if (cat) labels.push(cat);
    if (concern) labels.push(concern);
    if (price) labels.push("Rs. " + price);

    if (labels.length > 0) {
      countEl.innerHTML = "Showing <strong>" + visibleCount + "</strong> of " + cards.length + " products (" + labels.join(", ") + ")";
    } else {
      countEl.innerHTML = "Showing <strong>" + visibleCount + "</strong> of " + cards.length + " products";
    }
  }

  updateCollectionPaginationVisibility();
}

function clearAllCollectionFilters() {
  const cards = document.querySelectorAll(".collection-product-grid .product-card");
  cards.forEach(function(card) {
    card.setAttribute("data-brand-hidden", "false");
    card.setAttribute("data-concern-hidden", "false");
    card.setAttribute("data-category-hidden", "false");
    card.setAttribute("data-price-hidden", "false");
    card.style.display = "";
  });

  document.querySelectorAll(".brand-filter-link, .category-filter-link, .concern-filter-link, .price-filter-link").forEach(function(l) {
    l.style.fontWeight = "400";
    l.style.color = "var(--color-text-secondary)";
  });

  const clearBrandBtn = document.getElementById("clear-brand-filter");
  const clearCatBtn = document.getElementById("clear-category-filter");
  const clearConcernBtn = document.getElementById("clear-concern-filter");
  const clearPriceBtn = document.getElementById("clear-price-filter");
  if (clearBrandBtn) clearBrandBtn.style.display = "none";
  if (clearCatBtn) clearCatBtn.style.display = "none";
  if (clearConcernBtn) clearConcernBtn.style.display = "none";
  if (clearPriceBtn) clearPriceBtn.style.display = "none";

  const bannerTitle = document.getElementById("collection-banner-title");
  const bannerDesc = document.getElementById("collection-banner-desc");
  if (bannerTitle && bannerTitle.getAttribute("data-default-title")) {
    bannerTitle.textContent = bannerTitle.getAttribute("data-default-title");
  }
  if (bannerDesc && bannerDesc.getAttribute("data-default-desc")) {
    bannerDesc.textContent = bannerDesc.getAttribute("data-default-desc");
  }

  const u = new URL(window.location.href);
  u.searchParams.delete("brand");
  u.searchParams.delete("category");
  u.searchParams.delete("type");
  u.searchParams.delete("concern");
  u.searchParams.delete("price");
  if (window.location.pathname.indexOf("/collections/vendors") === -1) {
    u.searchParams.delete("q");
  }
  window.history.pushState({}, "", u.toString());

  syncCollectionVisibility();
}
window.clearAllCollectionFilters = clearAllCollectionFilters;

/* --- Main Unified Collection Filters Controller --- */
function initAllCollectionFilters() {
  const cards = document.querySelectorAll(".collection-product-grid .product-card");
  if (cards.length === 0) return;

  const bannerTitle = document.getElementById("collection-banner-title");
  const bannerDesc = document.getElementById("collection-banner-desc");
  if (bannerTitle && !bannerTitle.getAttribute("data-default-title")) {
    bannerTitle.setAttribute("data-default-title", bannerTitle.textContent);
  }
  if (bannerDesc && !bannerDesc.getAttribute("data-default-desc")) {
    bannerDesc.setAttribute("data-default-desc", bannerDesc.textContent);
  }

  const clearBrandBtn = document.getElementById("clear-brand-filter");
  const clearCatBtn = document.getElementById("clear-category-filter");
  const clearConcernBtn = document.getElementById("clear-concern-filter");
  const clearPriceBtn = document.getElementById("clear-price-filter");

  const brandDescriptions = {
    "CeraVe": "Dermatologist-developed skincare infused with three essential ceramides to restore the skin's natural protective barrier.",
    "The Ordinary": "Clinical formulations with integrity. Pure, science-backed active ingredients at accessible price points.",
    "Cetaphil": "Gentle, clinically-tested dermatological skincare recommended by dermatologists for sensitive, dry, and reactive skin types.",
    "COSRX": "Award-winning Korean skincare formulated with skin-friendly ingredients like Snail Mucin, Centella, and BHA to soothe and clarify.",
    "Medicube": "Advanced clinical dermacosmetics utilizing innovative skincare technology for pore refinement, glass skin, and deep rejuvenation.",
    "Beauty of Joseon": "Traditional Korean herbal Hanbang remedies reinterpreted with modern science for radiant, deeply nourished skin.",
    "K-SECRET": "Seoul-crafted skincare featuring high-potency retinal, collagen, and pure actives for rapid anti-aging and firming results.",
    "SKIN1004": "Pristine Madagascar Centella Asiatica skincare to calm irritation, repair weakened skin barriers, and soothe troubled skin.",
    "ANUA": "Calming skincare powered by Heartleaf extract to soothe sensitive skin, calm redness, and deliver balanced, lightweight hydration.",
    "THE ELF": "Premium intensive brightening body doses and skincare treatments engineered to boost radiance and even skin tone."
  };

  const categoryData = {
    "cleansers": {
      title: "Facial Cleansers & Face Wash",
      desc: "Purify, unclog pores, and refresh your skin with gentle, dermatologically-approved cleansers, foaming washes, and cleansing oils.",
      keywords: ["clean", "foam", "wash", "gel", "soap", "cleanser", "cleansing"]
    },
    "serums": {
      title: "Serums & Treatments",
      desc: "High-concentration active treatments formulated with Salicylic Acid, Niacinamide, Snail Mucin, Centella, and Hyaluronic Acid to treat specific concerns.",
      keywords: ["serum", "ampoule", "drop", "retinal", "niacinamide", "mucin", "peptide", "pdrn", "alpha", "arbutin", "caffeine", "salicylic", "solution", "bha", "acid", "treatment"]
    },
    "moisturizers": {
      title: "Creams & Moisturizers",
      desc: "Lock in deep cellular hydration and restore your natural barrier with ceramide-infused creams, soothing gel-creams, and lotions.",
      keywords: ["cream", "moist", "lotion", "jelly", "balm", "hydra", "hydrating", "soothing cream", "barrier", "collagen jelly", "succinic"]
    },
    "sunscreens": {
      title: "Daily Sunscreens & UV Protection",
      desc: "Lightweight, non-greasy, zero white-cast broad spectrum sun protection imported from top Korean and international brands.",
      keywords: ["sun", "spf", "uv", "shield", "hyalu-cica sun", "sunscreen", "pine tree", "aqua fresh", "rice + probiotics"]
    },
    "toners": {
      title: "Toners & Essences",
      desc: "Rebalance skin pH, prep pores, and hydrate deeply after cleansing with soothing, hydrating facial toners and essences.",
      keywords: ["toner", "toning", "essence", "pad", "clarifying", "treatment liquid", "aha/bha", "glycolic", "aha 7", "pink cica", "cica toner", "pink peptide", "pdrn pink peptide"]
    },
    "body-care": {
      title: "Body Care & Soaps",
      desc: "Pamper and nourish your body skin with brightening dose serums, hydrating body lotions, washes, and smoothing treatments.",
      keywords: ["body", "lotion", "shower", "scrub", "bath", "gluta hya", "soap", "kojic", "the elf", "the-elf", "elf", "nano white", "dose"]
    },
    "hair-care": {
      title: "Hair & Scalp Care",
      desc: "Nourishing shampoos, scalp serums, and hair strengthening treatments for lustrous, healthy hair.",
      keywords: ["hair", "shampoo", "scalp", "oil", "conditioner"]
    },
    "tools": {
      title: "Beauty Tools & Accessories",
      desc: "Facial rollers, gua sha, brushes, and skincare application tools to elevate your daily routine.",
      keywords: ["tool", "roller", "brush", "sponge", "device", "gua"]
    }
  };

  const concernData = {
    "acne-care": {
      name: "Acne & Blemishes",
      title: "Acne & Blemishes Solutions",
      desc: "Targeted dermatological formulas to clear breakouts, balance sebum, and soothe inflamed acne-prone skin."
    },
    "skin-brightening": {
      name: "Dark Spots / Brightening",
      title: "Dark Spots & Skin Brightening",
      desc: "Clinically proven treatments with Vitamin C, Niacinamide, and Alpha Arbutin to fade hyperpigmentation and reveal glowing skin."
    },
    "dry-skin": {
      name: "Dry Skin & Hydration",
      title: "Dry Skin & Deep Hydration",
      desc: "Intensive moisturizing and hydrating essentials with Hyaluronic Acid, Ceramides, and nourishing botanicals."
    },
    "oily-skin": {
      name: "Oily Skin & Large Pores",
      title: "Oily Skin & Large Pores",
      desc: "Clarifying cleansers, gentle exfoliants, and lightweight balancing serums to minimize pores and control shine."
    },
    "soothing": {
      name: "Sensitive Skin & Redness",
      title: "Sensitive Skin & Redness Relief",
      desc: "Gentle, barrier-repairing solutions with Centella Asiatica, Heartleaf, and calming botanicals to reduce redness."
    },
    "anti-aging": {
      name: "Anti-Aging",
      title: "Anti-Aging & Firming Care",
      desc: "Age-defying formulas infused with Retinal, Peptides, and Collagen to smooth fine lines, firm skin, and boost elasticity."
    }
  };

  const concernKeywords = {
    "acne-care": ["acne", "salicylic", "centella", "cleanser", "snail", "bha", "aha", "succinic", "blemish", "tea tree", "clarifying", "zinc", "foam", "pore", "soap"],
    "skin-brightening": ["bright", "glow", "niacinamide", "spot", "dark", "vitamin c", "arbutin", "kojic", "retinal", "pdrn", "alpha", "glut", "tone"],
    "dry-skin": ["hyaluron", "moist", "cream", "hydra", "birch", "collagen", "ceramide", "lotion", "soothing cream", "jelly"],
    "oily-skin": ["cleans", "pore", "oil", "foam", "toning", "salicylic", "bha", "sebum", "matt", "balance", "zinc"],
    "soothing": ["sooth", "calm", "centella", "relief", "heartleaf", "cica", "redness", "repair", "aloe", "barrier", "pine"],
    "anti-aging": ["retinal", "collagen", "serum", "peptide", "snail", "anti-aging", "firming", "wrinkle", "elasticity", "youth", "pdrn"]
  };

  const applyBrandFilter = function(brandName, updateUrl) {
    if (updateUrl === undefined) updateUrl = true;
    const links = document.querySelectorAll(".brand-filter-link");
    const allCards = document.querySelectorAll(".collection-product-grid .product-card");

    // Clear conflicting category and concern filters
    allCards.forEach(function(card) {
      card.setAttribute("data-category-hidden", "false");
      card.setAttribute("data-concern-hidden", "false");
    });
    document.querySelectorAll(".category-filter-link, .concern-filter-link").forEach(function(l) {
      l.style.fontWeight = "400";
      l.style.color = "var(--color-text-secondary)";
    });
    if (clearCatBtn) clearCatBtn.style.display = "none";
    if (clearConcernBtn) clearConcernBtn.style.display = "none";

    if (!brandName) {
      links.forEach(function(l) {
        l.style.fontWeight = "400";
        l.style.color = "var(--color-text-secondary)";
      });
      if (clearBrandBtn) clearBrandBtn.style.display = "none";
      if (bannerTitle && bannerTitle.getAttribute("data-default-title")) {
        bannerTitle.textContent = bannerTitle.getAttribute("data-default-title");
      }
      if (bannerDesc && bannerDesc.getAttribute("data-default-desc")) {
        bannerDesc.textContent = bannerDesc.getAttribute("data-default-desc");
      }

      allCards.forEach(function(card) {
        card.setAttribute("data-brand-hidden", "false");
      });

      if (updateUrl) {
        const u = new URL(window.location.href);
        u.searchParams.delete("brand");
        u.searchParams.delete("category");
        u.searchParams.delete("type");
        u.searchParams.delete("concern");
        if (window.location.pathname.indexOf("/collections/vendors") === -1) {
          u.searchParams.delete("q");
        }
        window.history.pushState({}, "", u.toString());
      }
      syncCollectionVisibility();
      return;
    }

    if (bannerTitle && !bannerTitle.getAttribute("data-default-title")) {
      bannerTitle.setAttribute("data-default-title", bannerTitle.textContent);
    }
    if (bannerDesc && !bannerDesc.getAttribute("data-default-desc")) {
      bannerDesc.setAttribute("data-default-desc", bannerDesc.textContent);
    }

    const normBrand = brandName.trim().toLowerCase();

    links.forEach(function(l) {
      const lBrand = (l.getAttribute("data-brand") || l.textContent || "").trim().toLowerCase();
      if (lBrand === normBrand || lBrand.indexOf(normBrand) !== -1 || normBrand.indexOf(lBrand) !== -1) {
        l.style.fontWeight = "700";
        l.style.color = "var(--color-accent-gold)";
      } else {
        l.style.fontWeight = "400";
        l.style.color = "var(--color-text-secondary)";
      }
    });

    if (clearBrandBtn) clearBrandBtn.style.display = "inline-block";

    if (bannerTitle) bannerTitle.textContent = brandName + " Products";
    if (bannerDesc) {
      bannerDesc.textContent = brandDescriptions[brandName] || ("Authentic " + brandName + " skincare products imported directly with 100% authenticity guarantee.");
    }

    allCards.forEach(function(card) {
      const cardVendor = (card.getAttribute("data-vendor") || "").trim().toLowerCase();
      const cardTitle = (card.getAttribute("data-title") || card.innerText || "").trim().toLowerCase();

      let isMatch = false;
      if (cardVendor && (cardVendor === normBrand || cardVendor.indexOf(normBrand) !== -1 || normBrand.indexOf(cardVendor) !== -1)) {
        isMatch = true;
      } else if (cardTitle.indexOf(normBrand) !== -1) {
        isMatch = true;
      } else {
        // Special brand aliases
        if ((normBrand === "skin1004" || normBrand === "skin1001" || normBrand === "skin 1004") &&
            (cardTitle.indexOf("skin1004") !== -1 || cardTitle.indexOf("skin1001") !== -1 || cardTitle.indexOf("skin 1004") !== -1 || cardTitle.indexOf("centella") !== -1 || cardTitle.indexOf("madagascar") !== -1 || cardVendor.indexOf("skin1004") !== -1 || cardVendor.indexOf("skin1001") !== -1)) {
          isMatch = true;
        }
        if (normBrand === "cosrx" && (cardTitle.indexOf("cosrx") !== -1 || cardVendor.indexOf("cosrx") !== -1)) isMatch = true;
        if (normBrand === "anua" && (cardTitle.indexOf("anua") !== -1 || cardTitle.indexOf("birch 70") !== -1 || cardTitle.indexOf("heartleaf") !== -1 || cardVendor.indexOf("anua") !== -1)) isMatch = true;
        if ((normBrand === "beauty of joseon" || normBrand === "joseon") && (cardTitle.indexOf("joseon") !== -1 || cardTitle.indexOf("boj") !== -1 || cardVendor.indexOf("joseon") !== -1)) isMatch = true;
        if ((normBrand === "the ordinary" || normBrand === "ordinary") && (cardTitle.indexOf("ordinary") !== -1 || cardVendor.indexOf("ordinary") !== -1)) isMatch = true;
        if (normBrand === "cerave" && (cardTitle.indexOf("cerave") !== -1 || cardVendor.indexOf("cerave") !== -1)) isMatch = true;
        if ((normBrand === "k-secret" || normBrand === "ksecret") && (cardTitle.indexOf("k-secret") !== -1 || cardTitle.indexOf("ksecret") !== -1 || cardTitle.indexOf("seoul 1988") !== -1 || cardVendor.indexOf("ksecret") !== -1 || cardVendor.indexOf("k-secret") !== -1)) isMatch = true;
        if (normBrand === "medicube" && (cardTitle.indexOf("medicube") !== -1 || cardVendor.indexOf("medicube") !== -1)) isMatch = true;
        if (normBrand === "cetaphil" && (cardTitle.indexOf("cetaphil") !== -1 || cardVendor.indexOf("cetaphil") !== -1)) isMatch = true;
        if ((normBrand === "axis-y" || normBrand === "axis y" || normBrand === "axis") && (cardTitle.indexOf("axis") !== -1 || cardVendor.indexOf("axis") !== -1)) isMatch = true;
        if (normBrand === "vaseline" && (cardTitle.indexOf("vaseline") !== -1 || cardTitle.indexOf("gluta hya") !== -1 || cardVendor.indexOf("vaseline") !== -1)) isMatch = true;
        if (normBrand === "beauty basket" && (cardTitle.indexOf("kojic") !== -1 || cardVendor.indexOf("beauty basket") !== -1)) isMatch = true;
        if ((normBrand === "the elf" || normBrand === "the-elf" || normBrand === "elf") && (cardTitle.indexOf("the elf") !== -1 || cardTitle.indexOf("elf") !== -1 || cardVendor.indexOf("elf") !== -1 || cardTitle.indexOf("nano white") !== -1)) isMatch = true;
      }

      card.setAttribute("data-brand-hidden", isMatch ? "false" : "true");
    });

    if (updateUrl) {
      const newUrl = new URL(window.location.href);
      newUrl.searchParams.delete("category");
      newUrl.searchParams.delete("type");
      newUrl.searchParams.delete("concern");
      newUrl.searchParams.delete("page");
      newUrl.searchParams.set("brand", brandName);
      window.history.pushState({}, "", newUrl.toString());
    }

    syncCollectionVisibility();
  };
  window.applyBrandFilter = applyBrandFilter;

  const applyCategoryFilter = function(categoryKey, updateUrl) {
    if (updateUrl === undefined) updateUrl = true;
    const links = document.querySelectorAll(".category-filter-link");
    const allCards = document.querySelectorAll(".collection-product-grid .product-card");

    // Clear conflicting brand and concern filters
    allCards.forEach(function(card) {
      card.setAttribute("data-brand-hidden", "false");
      card.setAttribute("data-concern-hidden", "false");
    });
    document.querySelectorAll(".brand-filter-link, .concern-filter-link").forEach(function(l) {
      l.style.fontWeight = "400";
      l.style.color = "var(--color-text-secondary)";
    });
    if (clearBrandBtn) clearBrandBtn.style.display = "none";
    if (clearConcernBtn) clearConcernBtn.style.display = "none";

    if (!categoryKey) {
      links.forEach(function(l) {
        l.style.fontWeight = "400";
        l.style.color = "var(--color-text-secondary)";
      });
      if (clearCatBtn) clearCatBtn.style.display = "none";
      if (bannerTitle && bannerTitle.getAttribute("data-default-title")) {
        bannerTitle.textContent = bannerTitle.getAttribute("data-default-title");
      }
      if (bannerDesc && bannerDesc.getAttribute("data-default-desc")) {
        bannerDesc.textContent = bannerDesc.getAttribute("data-default-desc");
      }

      allCards.forEach(function(card) {
        card.setAttribute("data-category-hidden", "false");
      });

      if (updateUrl) {
        const u = new URL(window.location.href);
        u.searchParams.delete("category");
        u.searchParams.delete("type");
        u.searchParams.delete("brand");
        u.searchParams.delete("concern");
        if (window.location.pathname.indexOf("/collections/vendors") === -1) {
          u.searchParams.delete("q");
        }
        window.history.pushState({}, "", u.toString());
      }
      syncCollectionVisibility();
      return;
    }

    if (bannerTitle && !bannerTitle.getAttribute("data-default-title")) {
      bannerTitle.setAttribute("data-default-title", bannerTitle.textContent);
    }
    if (bannerDesc && !bannerDesc.getAttribute("data-default-desc")) {
      bannerDesc.setAttribute("data-default-desc", bannerDesc.textContent);
    }

    let normCat = categoryKey.trim().toLowerCase();
    if (normCat === "soaps" || normCat === "soap" || normCat === "body" || normCat === "body-care-soaps" || normCat === "body-care-and-soaps" || normCat === "bodycare") {
      normCat = "body-care";
    } else if (normCat === "serum" || normCat === "treatment" || normCat === "treatments" || normCat === "serums-treatments" || normCat === "serums-and-treatments" || normCat === "serums-and-treatment") {
      normCat = "serums";
    } else if (normCat === "toner" || normCat === "toners" || normCat === "essence" || normCat === "essences" || normCat === "toners-and-essences" || normCat === "toners-and-essence" || normCat === "toners-essence" || normCat === "toners-essences") {
      normCat = "toners";
    }

    links.forEach(function(l) {
      const lCat = (l.getAttribute("data-category") || "").trim().toLowerCase();
      if (lCat === normCat) {
        l.style.fontWeight = "700";
        l.style.color = "var(--color-accent-gold)";
      } else {
        l.style.fontWeight = "400";
        l.style.color = "var(--color-text-secondary)";
      }
    });

    if (clearCatBtn) clearCatBtn.style.display = "inline-block";

    const info = categoryData[normCat] || {
      title: normCat.charAt(0).toUpperCase() + normCat.slice(1) + " Collection",
      desc: "Browse our curated selection of authentic skincare and cosmetic products.",
      keywords: [normCat]
    };

    if (bannerTitle) bannerTitle.textContent = info.title;
    if (bannerDesc) bannerDesc.textContent = info.desc;

    const keywords = info.keywords || [normCat];
    allCards.forEach(function(card) {
      const cardTitle = (card.getAttribute("data-title") || card.innerText || "").toLowerCase();
      const cardLink = card.querySelector("a[href*='/products/']");
      const cardHandle = (cardLink ? cardLink.getAttribute("href") : "").toLowerCase();

      let isMatch = false;
      for (let k = 0; k < keywords.length; k++) {
        if (cardTitle.indexOf(keywords[k]) !== -1 || cardHandle.indexOf(keywords[k]) !== -1) {
          isMatch = true;
          break;
        }
      }

      // Explicit category separation overrides
      if (normCat === "serums") {
        // Exclude all toners and essences moved to Toners & Essences (including Medicube PDRN Pink Cica and Medicube PDRN Pink Peptide)
        if (cardTitle.indexOf("toner") !== -1 || cardHandle.indexOf("toner") !== -1 || cardHandle.indexOf("pink-cica") !== -1 || cardTitle.indexOf("pink cica") !== -1 || cardTitle.indexOf("pink peptide") !== -1 || cardHandle.indexOf("pink-peptide") !== -1) {
          isMatch = false;
        }
        // Exclude cleansers and soaps from Serums & Treatments
        if (cardTitle.indexOf("cleanser") !== -1 || cardTitle.indexOf("cleansing") !== -1 || cardTitle.indexOf("soap") !== -1) {
          isMatch = false;
        }
      } else if (normCat === "toners") {
        // Ensure Medicube PDRN Pink Cica Toner and Medicube PDRN Pink Peptide Serum are explicitly included in Toners & Essences
        if (cardTitle.indexOf("pink cica") !== -1 || cardHandle.indexOf("pink-cica") !== -1 || cardTitle.indexOf("pink peptide") !== -1 || cardHandle.indexOf("pink-peptide") !== -1 || cardTitle.indexOf("toner") !== -1 || cardHandle.indexOf("toner") !== -1) {
          isMatch = true;
        }
      }

      card.setAttribute("data-category-hidden", isMatch ? "false" : "true");
    });

    if (updateUrl) {
      const newUrl = new URL(window.location.href);
      newUrl.searchParams.delete("brand");
      newUrl.searchParams.delete("concern");
      newUrl.searchParams.delete("page");
      if (window.location.pathname.indexOf("/collections/vendors") === -1) {
        newUrl.searchParams.delete("q");
      }
      newUrl.searchParams.set("category", categoryKey);
      window.history.pushState({}, "", newUrl.toString());
    }

    syncCollectionVisibility();
  };
  window.applyCategoryFilter = applyCategoryFilter;

  const applyConcernFilter = function(concernKey, updateUrl) {
    if (updateUrl === undefined) updateUrl = true;
    const links = document.querySelectorAll(".concern-filter-link");
    const allCards = document.querySelectorAll(".collection-product-grid .product-card");

    // Clear conflicting brand and category filters
    allCards.forEach(function(card) {
      card.setAttribute("data-brand-hidden", "false");
      card.setAttribute("data-category-hidden", "false");
    });
    document.querySelectorAll(".brand-filter-link, .category-filter-link").forEach(function(l) {
      l.style.fontWeight = "400";
      l.style.color = "var(--color-text-secondary)";
    });
    if (clearBrandBtn) clearBrandBtn.style.display = "none";
    if (clearCatBtn) clearCatBtn.style.display = "none";

    if (!concernKey || !concernData[concernKey]) {
      links.forEach(function(l) {
        l.style.fontWeight = "400";
        l.style.color = "var(--color-text-secondary)";
      });
      if (clearConcernBtn) clearConcernBtn.style.display = "none";
      if (bannerTitle && bannerTitle.getAttribute("data-default-title")) {
        bannerTitle.textContent = bannerTitle.getAttribute("data-default-title");
      }
      if (bannerDesc && bannerDesc.getAttribute("data-default-desc")) {
        bannerDesc.textContent = bannerDesc.getAttribute("data-default-desc");
      }

      allCards.forEach(function(card) {
        card.setAttribute("data-concern-hidden", "false");
      });

      if (updateUrl) {
        const u = new URL(window.location.href);
        u.searchParams.delete("concern");
        u.searchParams.delete("brand");
        u.searchParams.delete("category");
        u.searchParams.delete("type");
        if (window.location.pathname.indexOf("/collections/vendors") === -1) {
          u.searchParams.delete("q");
        }
        window.history.pushState({}, "", u.toString());
      }
      syncCollectionVisibility();
      return;
    }

    if (bannerTitle && !bannerTitle.getAttribute("data-default-title")) {
      bannerTitle.setAttribute("data-default-title", bannerTitle.textContent);
    }
    if (bannerDesc && !bannerDesc.getAttribute("data-default-desc")) {
      bannerDesc.setAttribute("data-default-desc", bannerDesc.textContent);
    }

    links.forEach(function(l) {
      if (l.getAttribute("data-concern") === concernKey) {
        l.style.fontWeight = "700";
        l.style.color = "var(--color-accent-gold)";
      } else {
        l.style.fontWeight = "400";
        l.style.color = "var(--color-text-secondary)";
      }
    });

    if (clearConcernBtn) clearConcernBtn.style.display = "inline-block";

    const info = concernData[concernKey];
    if (bannerTitle) bannerTitle.textContent = info.title;
    if (bannerDesc) bannerDesc.textContent = info.desc;

    const keywords = concernKeywords[concernKey] || [];
    allCards.forEach(function(card) {
      const cardConcerns = (card.getAttribute("data-concerns") || "").toLowerCase();
      const cardTitle = (card.getAttribute("data-title") || card.innerText || "").toLowerCase();

      let isMatch = cardConcerns.indexOf(concernKey) !== -1;
      if (!isMatch) {
        for (let k = 0; k < keywords.length; k++) {
          if (cardTitle.indexOf(keywords[k]) !== -1) {
            isMatch = true;
            break;
          }
        }
      }

      card.setAttribute("data-concern-hidden", isMatch ? "false" : "true");
    });

    if (updateUrl) {
      const newUrl = new URL(window.location.href);
      newUrl.searchParams.delete("brand");
      newUrl.searchParams.delete("category");
      newUrl.searchParams.delete("type");
      newUrl.searchParams.delete("page");
      if (window.location.pathname.indexOf("/collections/vendors") === -1) {
        newUrl.searchParams.delete("q");
      }
      newUrl.searchParams.set("concern", concernKey);
      window.history.pushState({}, "", newUrl.toString());
    }

    syncCollectionVisibility();
  };
  window.applyConcernFilter = applyConcernFilter;

  const applyPriceFilter = function(range, updateUrl) {
    if (updateUrl === undefined) updateUrl = true;
    const links = document.querySelectorAll(".price-filter-link");
    const allCards = document.querySelectorAll(".collection-product-grid .product-card");

    if (!range) {
      links.forEach(function(l) {
        l.style.fontWeight = "400";
        l.style.color = "var(--color-text-secondary)";
      });
      if (clearPriceBtn) clearPriceBtn.style.display = "none";
      allCards.forEach(function(card) {
        card.setAttribute("data-price-hidden", "false");
      });

      if (updateUrl) {
        const u = new URL(window.location.href);
        u.searchParams.delete("price");
        window.history.pushState({}, "", u.toString());
      }
      syncCollectionVisibility();
      return;
    }

    let minPrice = 0;
    let maxPrice = Infinity;
    if (range === "0-3000") {
      minPrice = 0; maxPrice = 3000;
    } else if (range === "3000-6000") {
      minPrice = 3000; maxPrice = 6000;
    } else if (range === "6000-9000") {
      minPrice = 6000; maxPrice = 9000;
    } else if (range === "9000-over") {
      minPrice = 9000; maxPrice = Infinity;
    } else if (range.indexOf("-") !== -1) {
      const parts = range.split("-");
      minPrice = parseFloat(parts[0]) || 0;
      maxPrice = parts[1] === "over" ? Infinity : (parseFloat(parts[1]) || Infinity);
    }

    links.forEach(function(l) {
      if (l.getAttribute("data-range") === range) {
        l.style.fontWeight = "700";
        l.style.color = "var(--color-accent-gold)";
      } else {
        l.style.fontWeight = "400";
        l.style.color = "var(--color-text-secondary)";
      }
    });

    if (clearPriceBtn) clearPriceBtn.style.display = "inline-block";

    allCards.forEach(function(card) {
      const priceAttr = card.getAttribute("data-price");
      const price = parseFloat(priceAttr) || 0;
      const isMatch = price >= minPrice && price <= maxPrice;
      card.setAttribute("data-price-hidden", isMatch ? "false" : "true");
    });

    if (updateUrl) {
      const newUrl = new URL(window.location.href);
      newUrl.searchParams.set("price", range);
      window.history.pushState({}, "", newUrl.toString());
    }

    syncCollectionVisibility();
  };
  window.applyPriceFilter = applyPriceFilter;

  // Brand Link Click Handlers
  document.querySelectorAll(".brand-filter-link").forEach(function(link) {
    link.addEventListener("click", function(e) {
      const clickedBrand = (this.getAttribute("data-brand") || this.textContent || "").trim();
      const currentParams = new URLSearchParams(window.location.search);

      if (currentParams.has("page")) {
        const newUrl = new URL(window.location.href);
        newUrl.searchParams.delete("page");
        newUrl.searchParams.delete("category");
        newUrl.searchParams.delete("type");
        newUrl.searchParams.delete("concern");
        newUrl.searchParams.set("brand", clickedBrand);
        window.location.href = newUrl.toString();
        return;
      }

      e.preventDefault();
      const currentActive = currentParams.get("brand");
      if (currentActive && currentActive.toLowerCase() === clickedBrand.toLowerCase()) {
        applyBrandFilter(null);
      } else {
        applyBrandFilter(clickedBrand);
      }
    });
  });

  if (clearBrandBtn) {
    clearBrandBtn.addEventListener("click", function(e) {
      e.preventDefault();
      applyBrandFilter(null);
    });
  }

  // Category Link Click Handlers
  document.querySelectorAll(".category-filter-link").forEach(function(link) {
    link.addEventListener("click", function(e) {
      const clickedCat = (this.getAttribute("data-category") || "").trim();
      const currentParams = new URLSearchParams(window.location.search);

      if (currentParams.has("page")) {
        const newUrl = new URL(window.location.href);
        newUrl.searchParams.delete("page");
        newUrl.searchParams.delete("brand");
        newUrl.searchParams.delete("concern");
        if (window.location.pathname.indexOf("/collections/vendors") === -1) {
          newUrl.searchParams.delete("q");
        }
        newUrl.searchParams.set("category", clickedCat);
        window.location.href = newUrl.toString();
        return;
      }

      e.preventDefault();
      const currentActive = currentParams.get("category") || currentParams.get("type");
      if (currentActive && currentActive.toLowerCase() === clickedCat.toLowerCase()) {
        applyCategoryFilter(null);
      } else {
        applyCategoryFilter(clickedCat);
      }
    });
  });

  if (clearCatBtn) {
    clearCatBtn.addEventListener("click", function(e) {
      e.preventDefault();
      applyCategoryFilter(null);
    });
  }

  // Concern Link Click Handlers
  document.querySelectorAll(".concern-filter-link").forEach(function(link) {
    link.addEventListener("click", function(e) {
      const clickedConcern = this.getAttribute("data-concern");
      const currentParams = new URLSearchParams(window.location.search);

      if (currentParams.has("page")) {
        const newUrl = new URL(window.location.href);
        newUrl.searchParams.delete("page");
        newUrl.searchParams.delete("brand");
        newUrl.searchParams.delete("category");
        newUrl.searchParams.delete("type");
        if (window.location.pathname.indexOf("/collections/vendors") === -1) {
          newUrl.searchParams.delete("q");
        }
        newUrl.searchParams.set("concern", clickedConcern);
        window.location.href = newUrl.toString();
        return;
      }

      e.preventDefault();
      const currentActive = currentParams.get("concern");
      if (currentActive === clickedConcern) {
        applyConcernFilter(null);
      } else {
        applyConcernFilter(clickedConcern);
      }
    });
  });

  if (clearConcernBtn) {
    clearConcernBtn.addEventListener("click", function(e) {
      e.preventDefault();
      applyConcernFilter(null);
    });
  }

  // Price Link Click Handlers
  document.querySelectorAll(".price-filter-link").forEach(function(link) {
    link.addEventListener("click", function(e) {
      const clickedRange = (this.getAttribute("data-range") || "").trim();
      const currentParams = new URLSearchParams(window.location.search);

      if (currentParams.has("page")) {
        const newUrl = new URL(window.location.href);
        newUrl.searchParams.delete("page");
        newUrl.searchParams.set("price", clickedRange);
        window.location.href = newUrl.toString();
        return;
      }

      e.preventDefault();
      const currentActive = currentParams.get("price");
      if (currentActive === clickedRange) {
        applyPriceFilter(null);
      } else {
        applyPriceFilter(clickedRange);
      }
    });
  });

  if (clearPriceBtn) {
    clearPriceBtn.addEventListener("click", function(e) {
      e.preventDefault();
      applyPriceFilter(null);
    });
  }

  // Initial Page Load URL Resolution & Conflict Cleanup
  const initParams = new URLSearchParams(window.location.search);
  const brandParam = initParams.get("brand") || (window.location.pathname.indexOf("/collections/vendors") !== -1 ? initParams.get("q") : null);
  const catParam = initParams.get("category") || initParams.get("type");
  const concernParam = initParams.get("concern");
  const priceParam = initParams.get("price");

  if (brandParam) {
    // If brand is active, remove conflicting category/type/concern from URL
    if (initParams.has("category") || initParams.has("type") || initParams.has("concern")) {
      const cleanUrl = new URL(window.location.href);
      cleanUrl.searchParams.delete("category");
      cleanUrl.searchParams.delete("type");
      cleanUrl.searchParams.delete("concern");
      window.history.replaceState({}, "", cleanUrl.toString());
    }
    applyBrandFilter(brandParam, false);
  } else if (catParam) {
    // If category is active and no brand, remove conflicting concern
    if (initParams.has("concern")) {
      const cleanUrl = new URL(window.location.href);
      cleanUrl.searchParams.delete("concern");
      window.history.replaceState({}, "", cleanUrl.toString());
    }
    applyCategoryFilter(catParam, false);
  } else if (concernParam) {
    applyConcernFilter(concernParam, false);
  }

  if (priceParam) {
    applyPriceFilter(priceParam, false);
  }
}

// Backward compatibility aliases
function initCollectionPriceFilter() { initAllCollectionFilters(); }
function initCollectionConcernFilter() { initAllCollectionFilters(); }
function initCollectionBrandFilter() { initAllCollectionFilters(); }
function initCollectionCategoryFilter() { initAllCollectionFilters(); }

// Shopify Customizer Section Re-render Listener
document.addEventListener("shopify:section:load", function(e) {
  if (e.target && e.target.querySelector && e.target.querySelector(".collection-product-grid")) {
    initAllCollectionFilters();
  }
});


/* --- Wishlist LocalStorage Sync --- */
function initWishlist() {
  const getWishlist = () => {
    try {
      return JSON.parse(localStorage.getItem("bb_wishlist")) || [];
    } catch(e) {
      return [];
    }
  };

  const saveWishlist = (list) => {
    try {
      localStorage.setItem("bb_wishlist", JSON.stringify(list));
    } catch(e) {}
    updateWishlistUI();
  };
  
  const updateWishlistUI = () => {
    const list = getWishlist();
    const cards = document.querySelectorAll(".wishlist-btn-card");
    cards.forEach(card => {
      const handle = card.getAttribute("data-product-handle");
      if (list.includes(handle)) {
        card.classList.add("active");
      } else {
        card.classList.remove("active");
      }
    });
    
    const countBadge = document.querySelector(".wishlist-count-badge");
    if (countBadge) {
      countBadge.textContent = list.length;
      countBadge.style.display = list.length > 0 ? "inline-block" : "none";
    }
  };
  
  document.body.addEventListener("click", function(e) {
    const btn = e.target.closest(".wishlist-btn-card");
    if (btn) {
      e.preventDefault();
      const handle = btn.getAttribute("data-product-handle");
      let list = getWishlist();
      
      if (list.includes(handle)) {
        list = list.filter(item => item !== handle);
      } else {
        list.push(handle);
      }
      
      saveWishlist(list);
    }
  });
  
  updateWishlistUI();
}

/* --- Product Accordion Tabs --- */
function initProductTabs() {
  document.body.addEventListener("click", function(e) {
    const header = e.target.closest(".accordion-header");
    if (header) {
      e.preventDefault();
      const tab = header.closest(".accordion-tab");
      const content = tab.querySelector(".accordion-content");
      if (!content) return;
      
      if (tab.classList.contains("active")) {
        tab.classList.remove("active");
        content.style.maxHeight = "0";
      } else {
        const siblings = tab.parentElement.querySelectorAll(".accordion-tab");
        siblings.forEach(sib => {
          sib.classList.remove("active");
          const sibContent = sib.querySelector(".accordion-content");
          if (sibContent) sibContent.style.maxHeight = "0";
        });
        
        tab.classList.add("active");
        content.style.maxHeight = content.scrollHeight + "px";
      }
    }
  });

  // Open default active tabs on load
  document.querySelectorAll(".accordion-tab.active").forEach(tab => {
    const content = tab.querySelector(".accordion-content");
    if (content) {
      content.style.maxHeight = content.scrollHeight + "px";
    }
  });
}

/* --- Sticky Add To Cart --- */
function initStickyATC() {
  const atcBar = document.querySelector(".sticky-atc");
  const mainBuyBtn = document.getElementById("main-add-to-cart-btn");
  
  if (!atcBar || !mainBuyBtn) return;
  
  if ("IntersectionObserver" in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting && window.scrollY > entry.boundingClientRect.top + window.scrollY) {
          atcBar.classList.add("active");
        } else {
          atcBar.classList.remove("active");
        }
      });
    }, { threshold: 0 });
    
    observer.observe(mainBuyBtn);
  }
}

/* --- WhatsApp Float Interaction --- */
function initWhatsAppFloating() {
  const btn = document.querySelector(".whatsapp-float-btn");
  if (!btn) return;
  btn.addEventListener("click", function() {
    console.log("WhatsApp contact clicked.");
  });
}

/* --- Intersection Observer Scroll Reveal --- */
function initScrollReveal() {
  const revealElements = document.querySelectorAll(".reveal-on-scroll");
  if (revealElements.length === 0) return;
  
  if ("IntersectionObserver" in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add("in-view");
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.05, rootMargin: "0px 0px -50px 0px" });
    
    revealElements.forEach(el => observer.observe(el));
  } else {
    revealElements.forEach(el => el.classList.add("in-view"));
  }
}
